// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-content{position:relative;box-sizing:border-box;overflow:hidden;height:100%;border:20px solid #f0f0f0;border-bottom-width:0;background:#fff;flex:1;padding:0 20px}", ""]);
// Exports
module.exports = exports;
